import { rd } from '@passionware/monads';
import {
  FeatureFlagFinalSource,
  FeatureFlagSource,
  FeatureFlagValues,
  FeatureGroupDefinition
} from '../feature-management';

export function withDefaultValues<Config extends FeatureGroupDefinition>(
  config: Config
) {
  return function createFeatureSource<Query = void>(
    source: FeatureFlagSource<Config, Query>
  ): FeatureFlagFinalSource<Config, Query> {
    return {
      useFeatureFlags: query => {
        const remoteData = source.useFeatureFlags(query);
        return rd.useMemoMap(
          remoteData,
          (flags, config) => ({
            ...config.groups.reduce((acc, group) => {
              group.entries.forEach(entry => {
                acc[entry.id] = entry.flagSpec.defaultValue;
              });
              return acc;
            }, {} as FeatureFlagValues<Config>),
            ...flags
          }),
          config
        );
      },
      ensureFeatureFlags: async query => {
        const flags = await source.getFeatureFlags(query);
        return {
          ...config.groups.reduce((acc, group) => {
            group.entries.forEach(entry => {
              acc[entry.id] = entry.flagSpec.defaultValue;
            });
            return acc;
          }, {} as FeatureFlagValues<Config>),
          ...flags
        };
      }
    };
  };
}
